import './tree-leaf-style.less';

let d3 = null;

let TreeCommonLeaf = class {
    constructor({dom, type = 'user', data, d3: _d3}) {
        d3 = _d3;
        this.dom = dom;
        this.type = type;
        this.data = data;
        this.exitHighLightNode = this.exitHighLightNode.bind(this);
        this.setHighLightNode = this.setHighLightNode.bind(this);
        this.tipTitle = this.tipTitle.bind(this);
        this.stopFlag = false; // 停止的flag
        this.constants();
        this.init();
        this.addToolTips();
    }

    init() {
        let {width, height} = this.dom.getBoundingClientRect();
        this.width = width;
        this.height = height;
        this.tree = d3.tree();
        this.tree.size([height, width]);
        this.svg = d3.select(this.dom)
            .classed('tree-common-leaf-mount', true).append('svg')
            .attr('width', width).attr('height', height);
        let transRight = this.sizeMap[0].width/2 + this.scale * 30;
        this.gRoot = this.g = this.svg.append('g')
            .attr('transform', `translate(${transRight}, 0)`);
        this.nodesTree = d3.hierarchy(this.data, d => d.children); // 树型数据结构
        this.nodesTree = this.tree(this.nodesTree); // 给树添加x、y值
        this.nodesList = this.nodesTree.descendants(); // 数组结构的节点  默认是垂直树，需转为水平树，x/y坐标调换
        this.uniqNode();
        this.fixPosition();
        this.createNodeGroup();
        this.drawNode();
        this.drawLink();
        this.bindEvent();
    }

    addToolTips () {
        this.tip = tippy('.text-box-tip-wrap');
        // tippy('.text-box-tip-wrap', {theme: 'light'});
    }

    createNodeGroup () {
        if (window['_screenType'] === '1080') {
            this.nodes = this.g.selectAll('.node')
                .data(this.nodesList).enter().append('g')
                .attr('class', d => `node node-group-${d.depth} node-group-${d.depth === 0 ? 'root' : 'tag'}`)
                .style('display', d => d._none_ === true ? 'none' : undefined)
                .attr('transform', d => `translate(${d.y},${d.x})`)
                // .attr('transform', d => `translate(${d.x},${d.y})`)
                .style('opacity', d => d.opacity ? d.opacity : undefined);
        }
        if (window['_screenType'] === '2160') {
            this.nodes = this.g.selectAll('.node')
                .data(this.nodesList).enter().append('g')
                .attr('class', d => `node node-group-${d.depth} node-group-tag`)
                .style('display', d => d._none_ === true ? 'none' : undefined)
                .attr('transform', d => `translate(${d.y},${d.x})`)
                // .attr('transform', d => `translate(${d.x},${d.y})`)
                .style('opacity', d => d.opacity ? d.opacity : undefined);
        }
    }

    tipTitle (d) {
        // return d.data.name;
        let nameMap = {
            '桂皮': '鲜香',
            '味精': '味道赞',
            '青少年': '人气旺',
        };
        let name = nameMap[ d.data.name] || d.data.name;
        if (d.depth === 1 && this.type === 'poi') {

            if (d.data.pos + d.data.mid === 0) {
                return `${name}\n`;
            }
            return `${name}\n<br/>喜欢${d.data.pos + d.data.mid}%\n`;
        }
        return name;
    }

    // 绘制具体的每一个Node
    drawNode () {
        let textColorMap = null;
        let baseFont = this.type === 'user' ? 20 : 16;
        textColorMap = {0: '#F9E559', 1: '#6CEEF6', 2: '#00F5FE', 3: '#F9E559'};
        if (window['_screenType'] === '1080') {
            textColorMap = {0: '#F9E559', 1: '#619EF5', 2: '#B9AC3F', 3: '#F9E559'};
        }
        if (this.type === 'user') {
            textColorMap = {0: '#F9E559', 1: '#75ABF9', 2: '#29BFCF', 3: '#B5A831'};
        }
        // 中心poi
        // let poiIconUrl = 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/d61dcb59-d964-4581-9a1f-4df05df9b4d2_1546486237367?filename=%E6%9C%AA%E6%A0%87%E9%A2%98-1_03.png';
        // let poiIconInnerUrl = 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/9f796fb9-0eb6-4246-a9ed-ba461ced4d0e_1546486707559?filename=%E6%9C%AA%E6%A0%87%E9%A2%98-1_06.png';

        let poiIconUrl = 'data:image/png;base64,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';
        if (this.type === 'user') {
            poiIconUrl = 'http://s3plus.sankuai.com/v1/mss_c9d411db85ec4b59aaebc4dfca416c55/image-hosting/0-kg-brain-case/user@2x.png';
        }
        this.nodes.filter('.node-group-root')
            .append('image')
            .attr('href', poiIconUrl)
            .attr('width', this.sizeMap[0].width)
            .attr('height', this.sizeMap[0].height)
            .style('transform', `translate(-${this.sizeMap[0].width/2}px, -${this.sizeMap[0].height/2}px)`);

        // this.nodes.filter('.node-group-root')
        //     .append('image')
        //     .attr('href', poiIconInnerUrl)
        //     .attr('width', this.sizeMap['0_inner'].width)
        //     .attr('height', this.sizeMap['0_inner'].height)
        //     .style('transform', `translate(-${this.sizeMap['0_inner'].width/2}px, -${this.sizeMap['0_inner'].height/2 - this.scale * 2}px)`);
        this.nodes.filter('.node-group-tag')
            .append('foreignObject')
            .attr('class', d => {
                if (this.type === 'user') {
                    return `user-text-wrap depth-${d.depth} type-${this.type}`;
                }
                return `text-wrap depth-${d.depth} type-${this.type}`;
            })
            .attr('width', d => this.sizeMap[d.depth].width)
            .attr('height', d => this.sizeMap[d.depth].height)
            .style('transform', d => {
                let {width, height} = this.sizeMap[d.depth];
                return `translate(-${width/2}px, -${height/2}px)`;
            })
            .append('xhtml:span').attr('class', 'text text-box-tip-wrap2')
            // .attr('title', this.tipTitle)
            .attr('data-tippy-content', this.tipTitle)
            .append('xhtml:span').attr('class', 'text-inner')
            .text(d => {
                let name = d.data.name;
                let nameMap = {
                    '桂皮': '鲜香',
                    '味精': '味道赞',
                    '青少年': '人气旺',
                };
                return nameMap[name] || name;
            })
            .style('font-size', this.scale * baseFont + 'px')
            // .style('padding', this.scale * 14 + 'px')
            .style('padding', this.scale * baseFont + 'px')
            .style('color', d => textColorMap[d.depth]);

        // 血槽
        if (this.type === 'poi') {
            let groupNodes = this.nodes.filter('.node-group-1');
            let processNodes = groupNodes.append('g')
                .attr('class', 'process')
                .attr('transform', d => {
                    let {width, height} = this.sizeMap[d.depth];
                    return `translate(-${ width / 2}, -${ height / 2})`;
                });
            processNodes.append('defs').append('clipPath')
                .attr('id', d =>`clip_tree_${d._index}`)
                .append('rect')
                .attr('x', 0)
                .attr('y', 0)
                .attr('width', d => (d.data.pos + d.data.mid) * this.sizeMap[d.depth].width / 100)
                .attr('height', d => this.sizeMap[d.depth].height);
            processNodes
                .append('foreignObject')
                .attr('width', d => this.sizeMap[d.depth].width)
                .attr('height', d => this.sizeMap[d.depth].height)
                .attr('class', 'process-bg')
                .attr('clip-path', d => `url(#clip_tree_${d._index})`);
        }

        // 有hover功能的节点最后加上去
        this.nodes
            .append('rect').classed('node-rect text-box-tip-wrap', true)
            .attr('width', d => this.sizeMap[d.depth].width)
            .attr('height', d => this.sizeMap[d.depth].height)
            .attr('data-tippy-content', this.tipTitle)
            .attr('data-tippy-arrow', 'true')
            .attr('transform', d => `translate(${-this.sizeMap[d.depth].width/2}, ${-this.sizeMap[d.depth].height/2})`);
    }

    drawLink () {
        let gapCalc = (type, depth) => {
            let map = {
                0: this.sizeMap[0].width/2,
                1: this.sizeMap[1].width/2,
                2: this.sizeMap[2].width/2,
                3: this.sizeMap[3].width/2,
            };
            return type === 'source' ? map[depth] : -(map[depth]);
        };

        this.links = this.g.selectAll('.link')
            .data(this.linksData).enter().append('path')
            .attr('class', d => 'link')
            .attr('d', function(d) {
                let sourceY = d.source.y + gapCalc('source', d.source.depth);
                let targetY = d.target.y + gapCalc('target', d.target.depth);
                let sourceX = d.source.x;
                let targetX = d.target.x;
                return "M" + targetY + "," + targetX
                    + "C" + (targetY + sourceY) / 2 + "," + targetX
                    + " " + (targetY + sourceY) / 2 + "," + sourceX
                    + " " + sourceY + "," + sourceX;
            });
    }

    // 位置修复
    fixPosition () {
        let scale = this.scale;
        // scale = 1;
        // 横向分割空间
        let depthLeftMap = {
            0: -10,
            1: 100 * scale,
            2: 160 * scale,
            3: 160 * scale,
        };
        if (this.type === 'user') {
            depthLeftMap = {
                0: -20,
                1: 100 * scale,
                2: 160 * scale,
                3: 200 * scale,
            };
        }
        if (window['_screenType'] === '2160') {
            depthLeftMap = {
                0: -20,
                1: 120 * scale,
                2: 240 * scale,
                3: 360 * scale,
            };
        }
        this.nodesList.forEach((d, index) => {
            d._index = index;
            d.y = d.y - depthLeftMap[d.depth];
        });

        // 纵向均分
        this.nodesVerticalAverage(3); // 店菜的标签
        this.nodesVerticalAverage(2); // 店菜的标签
        this.nodesVerticalAverage(1); // 店菜
        this.nodesVerticalAverage(0); // 店菜
    }

    // 去重节点
    // 思路 https://syean.cn/2017/06/27/d3%E6%A0%91%E5%9B%BE-tree-%E7%9A%84%E5%8F%98%E5%BD%A2%EF%BC%9A%E6%8B%A5%E6%9C%89%E5%A4%9A%E4%B8%AA%E7%88%B6%E8%8A%82%E7%82%B9%E7%9A%84%E5%AD%90%E8%8A%82%E7%82%B9/
    uniqNode () {
        let nodesLen = this.nodesList.length;

        // 找到重复的节点
        let tmpList = [this.nodesList[nodesLen-1]]; // 把最后一个节点放进去
        for (let i = nodesLen - 1; i > -1; i--) {
            let curNode = this.nodesList[i];
            let m = d3.map(tmpList, d => d.data.name);
            if (!m.has(curNode.data.name)) {
                tmpList.push(curNode);
            } else {
                curNode._none_ = true;
            }
        }

        // 生成links
        let linksData = [];
        let nodesMap = d3.map(this.nodesList, d => d.data.name);

        // 递归连线
        let traverseTree = (node) => {
            let parentNode = nodesMap.get(node.name);
            if (!(node && node.children && node.children.length > 0)) {
                return void 0;
            }
            for (let i = 0; i < node.children.length; i++) {
                let childNode = nodesMap.get(node.children[i].name);
                if (parentNode._none_ !== true && childNode._none_ !== true) {
                    let tempLink = {source: parentNode, target: childNode};
                    linksData.push(tempLink);
                }
                traverseTree(node.children[i]); // 子元素会变成下一个父元素
            }
        };
        traverseTree(this.data);
        this.linksData = linksData;
    }

    nodesVerticalAverage (depth) {
        let selectNodes = this.nodesList.filter(_ => _.depth === depth && _._none_ !== true);
        let len = selectNodes.length;
        let unit = this.height / (len + 1);
        // 为什么要reverse 为了让顺序不乱啊 o(╥﹏╥)o
        selectNodes.reverse().forEach((item, index) => {
            item.x = unit * (len - index);
        });
    }

    constants () {
        // this.scale = window.innerHeight / 1080;
        this.scale = this.type === 'user' ? window.innerHeight / ( 512 * 3) : window.innerHeight / ( 512 * 2);
        let scale = this.scale;

        this.sizeMap = {
            // 0: {width: 60, height: 60},
            0: {width: 50, height: 50},
            '0_inner': {width: 33, height: 28},
            1: {width: 120, height: 40},
            2: {width: 120, height: 40},
            3: {width: 120, height: 40},
        };

        if (window['_screenType'] === '2160') {
            this.sizeMap = {
                // 0: {width: 60, height: 60},
                0: {width: 125, height: 50},
                '0_inner': {width: 33, height: 28},
                1: {width: 125, height: 50},
                2: {width: 125 * 0.97, height: 50 * 0.97},
                3: {width: 125, height: 50},
            };
        }


        for (let item in this.sizeMap) {
            let value = this.sizeMap[item];
            value.width = value.width * scale;
            value.height = value.height * scale;
        }
    }

    bindEvent () {
        this.nodes.on('mouseenter', this.setHighLightNode).on('mouseleave', this.exitHighLightNode);
    }

    setHighLightNode (d) {
        let curName = d.data.name;
        this.nodesList.forEach(_ => {
            _.selected = undefined;
            _.selectedStart = undefined
        });
        d.selectedStart = true; // 选中的节点
        this.linksData.forEach(_ => {
            if (_.source.data.name === curName || _.target.data.name === curName) {
                _.source.selected = true;
                _.target.selected = true;
            }
        });
        this.nodesList.forEach(_ => _.selected === true ? undefined : _.selected = false);
        d.selected = true;
        this.nodes.data(this.nodesList).classed('tree-node-opacity', _ => _.selected === false ? true : undefined);
        this.links.data(this.linksData).classed('tree-node-opacity', _ => _.source.selectedStart !== true && _.target.selectedStart !== true);
        this.links.data(this.linksData).classed('tree-link-high-light', _ => _.source.selectedStart === true || _.target.selectedStart === true);

    };

    exitHighLightNode (d) {
        this.nodesList.forEach(_ => {
            _.selected = undefined;
            _.selectedStart = undefined
        });
        this.nodes.data(this.nodesList).classed('tree-node-opacity', false).classed('tree-node-full', true);
        this.links.data(this.linksData).classed('tree-node-opacity', false).classed('tree-node-full', true);
        this.links.data(this.linksData).classed('tree-link-high-light', false);

    };

    async animation () {
        let liveNodesList = this.nodesList.filter(node => node.depth === 1);
        for (let i = 0, len = liveNodesList.length; i < len; i++) {
            if (this.stopFlag === true) {
                return false;
            }
            let node = liveNodesList[i];
            this.setHighLightNode(node);
            await $sleep(800);
            this.exitHighLightNode();
            await $sleep(200);
        }
    };

    stop () {
        this.stopFlag = true;
    };

    destroy () {
        // TODO 以后再说吧
        this.stop();
        let arr = ['dom', 'type', 'data', 'tree', 'svg', 'g'];
        arr.forEach(item => this[item] = null);
        arr = null;
        d3 = null;
        this.tip.destroyAll();
        this.tip = null;
    }
};

export default TreeCommonLeaf;
